/**
 * Backend DTO - User data returned from the backend API
 */
export interface UserDto {
  id: number;
  fullName: string;
  shortName: string | null;
  email: string;
  roleId: number;
  role: string;
  accessToken: string;
  isLocked?: boolean;
  useEntraIdAuth?: boolean;
  authProvider?: AuthProvider;
}

export enum AuthProvider {
  Local = "Local",
  EntraInternal = "EntraInternal",
  EntraExternal = "EntraExternal",
}

/**
 * User object derived ONLY from JWT claims.
 * This should never be stored in local storage except for the accessToken.
 * User identity should always be extracted from the JWT token itself.
 */
export interface JwtUser {
  sub: string; // User ID from 'sub' claim
  name: string; // User name from 'name' claim
  roleId: number; // User role ID from 'role' claim (1=Admin, 2=Manager, 3=Reviewer)
  accessToken: string; // JWT token for API requests
}

export interface UserStats {
  id: number;
  fullName: string;
  email: string;
  workerSpeed: number;
  deficiencies: number;
  hoursWorked: number;
  inReview: number;
}

export enum Roles {
  None = 0,
  Admin = 1,
  Manager = 2,
  Reviewer = 3,
}
